export enum IconName {
  ALERT_TRIANGLE = 'alert-triangle',
  CHECKED_CIRCLE = 'checked-circle',
  ALERT_CIRCLE = 'alert-circle',
  GDPR = 'GDPR',
  SEARCH = 'search-2',
  MAIL = 'mail',
  INFO = 'info'
}
